import { RouteObject } from "react-router-dom";
import HomePage from "../pages/home/page";
import ServiciosPage from "../pages/servicios/page";
import ColaboradoresPage from "../pages/colaboradores/page";
import BlogPage from "../pages/blog/page";
import ArticlePage from "../pages/blog/ArticlePage";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/servicios",
    element: <ServiciosPage />,
  },
  {
    path: "/colaboradores",
    element: <ColaboradoresPage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/blog/:slug",
    element: <ArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
